// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "37cbbb8a4b64da53c552" + ".chunk.js";
};